import { render, staticRenderFns } from "./AEMFooter.vue?vue&type=template&id=988b8342"
import script from "./AEMFooter.vue?vue&type=script&lang=js"
export * from "./AEMFooter.vue?vue&type=script&lang=js"
import style0 from "./AEMFooter.vue?vue&type=style&index=0&id=988b8342&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports